var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"mint-button",attrs:{"disabled":!_vm.buyEnabled},on:{"click":_vm.clickAction}},[(_vm.buyEnabled === true)?_c('div',[_vm._v(" "+_vm._s(_vm.buttonText)+" ")]):_c('div',[_c('div',{staticClass:"loading-circle"}),_c('span',{staticClass:"pending-text"},[_vm._v("Transaction Pending")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }